// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ZhCK","delete":"styles_delete__2cQQk","update":"styles_update__3SmOZ","add":"styles_add__2FfDb"};